var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"flex gap-3 items-center",class:[_vm.sizeClasses.text, {
    'cursor-pointer': !_vm.disabled,
  }]},[_c('input',{staticClass:"focus:ring-blue-500 text-blue-600 border-gray-300 rounded-md pointer-events-none",class:_vm.sizeClasses.checkbox,attrs:{"id":"form-editor-customizedform","type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.model},on:{"change":_vm.handleChange}}),(_vm.label)?_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }